

































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class DialogConfirm extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: Boolean, default: true }) readonly closeOnConfirm!: boolean
  @Prop({ type: String, default: 'Xác nhận' }) readonly confirmText!: string
  @Prop({ type: String, default: 'Hủy' }) readonly cancelText!: string

  @Emit()
  confirm () {
    if (this.closeOnConfirm) {
      this.closeDialog()
    }
  }

  @Emit()
  cancel () {
    this.closeDialog()
  }

  @Emit('input')
  closeDialog () { return false }
}
